/**
 * @file topicContent-state
 */
import SelectOptions from './constants';
import officialProcessState from './officialProcess';

export default {
    topicData: {},
    questionFeedbackId: 0,
    fixedFeedbackId: 0,
    replyData: {},
    relatedLinkList: [],
    defaultRelatedLink: [{
        id: '380',
        from: 'devdocs',
        boardName: '开发',
        tagName: '介绍',
        title: '欢迎开发智能小程序',
        path: '/docs/develop/fuctionlist/list/',
        type: 0,
        issueId: 0,
        replyCount: 0
    }],
    // 帖子类型，用于判断是否为issue
    isIssueType: false,
    // issuet头部高度
    issueHeaderHeight: 120,
    isReplyShow: false,
    ...SelectOptions,
    ...officialProcessState
};
